<template>
  <div class="u-wrap">
    <van-form>
      <van-field :required="true" v-model="model.name" label="姓名" placeholder="请输入姓名" input-align="right" />
      <van-field :required="true" v-model="model.sjh" label="电话" placeholder="请输入手机号码" input-align="right" />
      <u-select
        dictCode="sex"
        readonly
        clickable
        v-model="model.xb"
        label="性别"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
      ></u-select>
      <u-time
        readonly
        clickable
        v-model="model.csrq"
        label="出生日期"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
      ></u-time>
      <u-picker
        dictCode="yes_or_no"
        readonly
        clickable
        v-model="model.sfdy"
        label="是否党员"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
      ></u-picker>

      <van-field
        :required="true"
        readonly
        clickable
        name="area"
        :value="model.sysOrgCode_dictText"
        label="报到社区"
        input-align="right"
        placeholder="请选择"
        @click="show = true"
        right-icon="arrow-down"
      />
      <van-field
        :required="true"
        readonly
        clickable
        name="area"
        :value="bddyyxgzName"
        label="意向工作"
        input-align="right"
        placeholder="请选择"
        @click="clickYxgz"
        right-icon="arrow"
      />

      <u-picker
        dictCode="zyly"
        readonly
        clickable
        v-model="model.scly"
        label="擅长领域"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
      ></u-picker>
      <u-picker
        dictCode="bddycysj"
        :required="true"
        readonly
        clickable
        v-model="model.bddycysj"
        label="参与时间"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
      ></u-picker>
      <van-popup v-model="show" position="bottom">
        <van-picker show-toolbar :columns="xzzzList" @confirm="onConfirm" @cancel="show = false" value-key="title" />
      </van-popup>
      <van-popup v-model="showYxgz" position="bottom" :style="{ height: '55%' }">
        <div class="pop-content">
          <div class="pop-title">
            <span class="qd">最少选择三项</span>
          </div>
          <div class="pop-c">
            <u-checkbox ref="checkBox" style="padding: 0 12px" @change="onChange"></u-checkbox>
          </div>
        </div>
      </van-popup>
    </van-form>
    <div class="b-btn">
      <button class="b-button" :disabled="disable" @click="clickSumbit">提交</button>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import uSelect from '@/components/page/u-select.vue'
import uPicker from '@/components/page/u-picker.vue'
import uTime from '@/components/page/u-time.vue'
import { isMobile, isCardID } from '@/utils/validate'
import uCheckbox from '@/components/page/u-checkbox.vue'
export default {
  components: {
    uSelect,
    uPicker,
    uTime,
    uCheckbox,
  },
  data() {
    return {
      url: '/zhshj/djyjdybd/add',
      model: {
        name: '',
        sjh: '',
        xb: '',
        csrq: '',
        sfdy: '',
        sysOrgCode: '', //报到社区
        bddyyxgz: '',
        bddycysj: '',
        scly: '',
      },
      bddyyxgzName: '',
      show: false,
      columns: [],
      showYxgz: false,
      xzzzList: [],
    }
  },
  created() {
    this.initData()
    this.initType()
    this.initXzzz()
  },
  computed: {
    disable() {
      let validate = true
      if (this.model.name && this.model.sjh && this.model.sysOrgCode && this.model.bddycysj && this.model.bddyyxgz) {
        validate = false
      }
      return validate
    },
  },
  methods: {
    clickQd() {},
    onChange(e) {
      if (e) {
        this.model.bddyyxgz = e.map((obj) => obj.value).join(',')
        this.bddyyxgzName = '已选择'
      } else {
        this.bddyyxgzName = ''
        this.model.bddyyxgz = ''
      }
    },
    change(index) {
      this.currentTab = index
    },
    initData() {
      getAction('/zhshj/djyjdybd/get/bddy').then((res) => {
        if (!res.success) {
          const content = res.message
          this.showDialog(content)
        }
      })
    },
    initXzzz() {
      let params = { category: '2' }
      getAction('/sys/sysDepart/queryTreeList/by/category/xzzz', params).then((res) => {
        if (res.success) {
          let list = res.result
          this.xzzzList = list
        }
      })
    },
    initType() {
      getAction('/sys/dict/getDictItems/bddyyxgz').then((res) => {
        if (res.success) {
          let list = res.result
          this.columns = list
        }
      })
    },
    showDialog(content) {
      this.$dialog
        .alert({
          title: '提示',
          message: content,
          confirmButtonText: '确定',
          confirmButtonColor: '#3f8ffb',
        })
        .then(() => {
          this.$router.go(-1)
        })
    },
    clickSumbit() {
      if (!isMobile(this.model.sjh)) {
        this.$toast('请输入正确手机号')
        return
      }

      let selectList = this.model.bddyyxgz.split(',')
      if (selectList.length < 3) {
        this.$toast('意向工作至少选择三项')
        return
      }

      postAction(this.url, this.model).then((res) => {
        if (res.success) {
          this.$router.replace({
            name: 'success',
            params: {
              isBack: true,
            },
          })
        }else{
          this.$toast(res.message);
        }
      })
    },
    onConfirm(value, index) {
      this.model.sysOrgCode_dictText = value.join('-')
      let index1 = index[0]
      let index2 = index[1]
      let index3 = index[2]
      try {
        let sysOrgCode = this.xzzzList[index1].children[index2].children[index3].orgCode
        this.model.sysOrgCode = sysOrgCode
      } catch (error) {}

      this.show = false
    },
    clickYxgz() {
      this.showYxgz = true
      this.$nextTick((res) => {
        this.$refs.checkBox.set({
          type: 'checkbox', //
          list: this.columns,
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
}
* {
  box-sizing: border-box;
}
.u-wrap /deep/ .van-button--primary {
  background-color: #3f8ffb;
  border: 1px solid #3f8ffb;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 12px 8px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 60px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  margin-top: 20px;
  padding: 0 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
.pop-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .pop-title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;
    font-size: 15px;

    .qd {
      color: #3f8ffb;
    }
  }

  .pop-c {
    flex: 1;
    overflow: hidden;
    overflow-y: scroll;
    padding: 10px 0;
  }
}
</style>
